import { render, staticRenderFns } from "./ModalScharffPointType2Package.vue?vue&type=template&id=92b1da3a&"
import script from "./ModalScharffPointType2Package.vue?vue&type=script&lang=js&"
export * from "./ModalScharffPointType2Package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports